const MODULE_DESTINATIONS = {
  request: { url: "/requests", label: "Open requests", location: "Requests" },
  calendar: { url: "/calendar", label: "Open calendar", location: "Calendar" },
  todo: { url: "/productivity?section=tasks", label: "Open tasks", location: "Productivity tasks" },
  "todo-reminder": { url: "/productivity?section=tasks", label: "Open tasks", location: "Productivity tasks" },
  conflict: { url: "/conflict-resolution", label: "Open conflict cases", location: "Conflict resolution" },
};

export function getNotificationActionUrl(notification) {
  const actionUrl = String(notification?.actionUrl || "").trim();
  if (actionUrl.startsWith("/")) return actionUrl;
  return MODULE_DESTINATIONS[String(notification?.type || "").toLowerCase()]?.url || "";
}

export function getNotificationActionLabel(notification) {
  const actionLabel = String(notification?.actionLabel || "").trim();
  if (actionLabel) return actionLabel;
  return MODULE_DESTINATIONS[String(notification?.type || "").toLowerCase()]?.label || "Open related item";
}

export function getNotificationDestinationDescription(notification) {
  const actionUrl = String(notification?.actionUrl || "").trim();
  if (actionUrl.startsWith("/")) {
    return { isDirect: true, location: actionUrl };
  }

  const destination = MODULE_DESTINATIONS[String(notification?.type || "").toLowerCase()];
  return destination
    ? { isDirect: false, location: destination.location }
    : null;
}
